module.exports = __webpack_public_path__ + "266572d85eb89088848e79aac93dea2a.png";